export default {
  name: "System"
};